import { createSelector, createSelectorCreator } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";
import { APP_POPOVERS, POPOVER_IDS } from "./constant";
import { TAppPopover, TPopoverIds } from "./types";
import { createEntitySelectors } from "../utils/createEntitySelectors";

export const selectPopoverState = (state: RootState) => state.popoverState;

export const selectAppPopovers = createSelector(
  selectPopoverState,
  (state) => state.appPopovers,
);

export const popoverSelectors = createEntitySelectors<TAppPopover, TPopoverIds>(
  selectAppPopovers,
  POPOVER_IDS,
);
